import React, { useMemo } from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import { shuffleArray } from '../../../../../../utils';
import ViewerErrorBoundary from '../../../common/ViewerConclusion/ViewerErrorBoundary';
import { QuestionText, StyledSelect } from '../../QuestionViewer.styles';
const MatchQuestionChoice = styled.div `
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
`;
const MatchQuestionViewer = ({ componentValues, setAnswer, answer = {}, disabled }) => {
    const { question, answerOptions, matchingPairs, hasRandomOrder } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const handleChange = (event) => {
        const { name: choiceKey, value: selectedAnswer } = event.target;
        if (choiceKey) {
            setAnswer(Object.assign(Object.assign({}, answer), { [choiceKey]: selectedAnswer }));
        }
    };
    const possibleAnswers = useMemo(() => (hasRandomOrder ? shuffleArray(answerOptions) : answerOptions), [
        answerOptions,
        hasRandomOrder
    ]);
    const renderChoices = () => {
        if (possibleAnswers) {
            return possibleAnswers.map((possibleAnswer) => {
                var _a;
                return (React.createElement(MatchQuestionChoice, { key: possibleAnswer.key },
                    React.createElement("p", { key: possibleAnswer.key }, possibleAnswer.text),
                    React.createElement(StyledSelect, { key: `select${possibleAnswer.key}`, variant: "outlined", name: possibleAnswer.key, value: (_a = answer === null || answer === void 0 ? void 0 : answer[possibleAnswer.key]) !== null && _a !== void 0 ? _a : '', onChange: handleChange, inputProps: {
                            'aria-label': `Match ${possibleAnswer.text} with the best answer`,
                            'data-testid': `select${possibleAnswer.key}`
                        }, native: true, disabled: disabled },
                        React.createElement("option", { "data-testid": `select-${possibleAnswer.key}-empty-option`, value: "", disabled: true, hidden: true }),
                        renderMatchingPairs())));
            });
        }
        return null;
    };
    const renderMatchingPairs = () => {
        if (matchingPairs && typeof matchingPairs === 'object') {
            return Object.entries(matchingPairs).map(([pairKey, pairValue]) => (React.createElement("option", { key: pairKey, value: pairValue === null || pairValue === void 0 ? void 0 : pairValue.key }, pairValue === null || pairValue === void 0 ? void 0 : pairValue.text)));
        }
        return null;
    };
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(QuestionText, null, question),
        React.createElement(Box, { display: "flex", flexDirection: "column" }, renderChoices())));
};
export default MatchQuestionViewer;
//# sourceMappingURL=index.js.map